export default "__VITE_ASSET__DS7TNxEL__"